import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';
import { useRef } from 'react';

interface TestAgentData {
  branch: string;
  inputObject?: string;
  sourceExample?: {
    uuid: string;
    container: string;
  };
  agentUuid2: string;
  runUuid: string;
  configuration?: Record<string, any>;
}

interface TestAgentResponse {
  runUuid: string;
}

export function useTestAgent() {
  const { keycloak } = useKeycloak();
  const abortController = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (testData: TestAgentData): Promise<TestAgentResponse> => {
      abortController.current = new AbortController();

      const body = {
        data: {
          uuid: 'test_agent',
          abstractUuid: 'test_agent',
          chainUuid: 'test_agent',
          title: 'test_agent',
          type: 'object',
          objectType: 'bundleFunction',
          bundleFunction: 'agent_runtime.test_agent',
          abstract: {
            data: {},
          },
          runtime: {
            data: testData,
          },
        },
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_AI_ENGINE_ENDPOINT
        }/api/v1/bundles/agent_runtime_bundle/functions/test_agent`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(body),
          signal: abortController.current.signal,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || 'Failed to test agent');
      }

      return data?.data;  
    }
  });

  return {
    ...mutation,
    abort: () => abortController.current?.abort(),
  };
}
